import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from './../../../../pages/employee/services/employee.service';

@Component({
  selector: 'app-multi-match-credit-card-modal',
  templateUrl: './multi-match-credit-card-modal.component.html',
  styleUrls: ['./multi-match-credit-card-modal.component.css']
})
export class MultiMatchCreditCardModalComponent implements OnInit {
  @Input() pendingGrid: any;
  @Input() currency: any;
  @Input() selectedEmployee: any;
  @Input() transID: any;
  formData: { [key: string]: any } = {};
  pendingList: any[] = [];

  constructor(public activeModal: NgbActiveModal, private employeeService: EmployeeService) { }

  ngOnInit(): void {
    this.pendingGrid.forEach((val: any) => {
      if (val.ExpenseTransID == null)
        this.pendingList.push(val);
    })
    this.pendingList.forEach((val: any) => {
      val.displayValue = val.ExpenseDateDisplay + " " + (val.Description == null ? "" : val.Description) + " " + this.currency + (val.Amount == null ? "0.00" : val.Amount)
    })
  }

  creditCardAction() {
    this.employeeService.transAction(this.transID, (this.selectedEmployee === null ? null : this.selectedEmployee.UserKeyID), "M", this.formData.selectedExpenseItem.ExpenseItemID, null).then((response: any) => {
      this.activeModal.close("recordMatched");
    });
  }

  cancelClicked() {
    this.activeModal.close("cancel");
  }
}
